export default "__VITE_ASSET__adcbaa49__"